import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteFlow(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteFlow = (flowId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`flows/${flowId}/`);
  };

  return useMutation(deleteFlow, {
    onSuccess: () => {
      queryClient.removeQueries(['flows']);
    },
  });
}
